import React, { useState } from 'react';
import { Alert, Button, Descriptions, Form, Input, message, Modal, Space } from 'antd';
import { sendPendingCouponV2Api } from '@/api/pointCenter/order';
import { buildPendingCouponPayload, PendingCouponFormValues } from './utils';
import styles from './index.module.scss';

const ReissueThirdCoupon: React.FC = () => {
  const [form] = Form.useForm<PendingCouponFormValues>();
  const [submitLoading, setSubmitLoading] = useState(false);

  const doSubmit = async (payload: ReturnType<typeof buildPendingCouponPayload>) => {
    setSubmitLoading(true);
    try {
      const res = await sendPendingCouponV2Api(payload);
      if (res?.code === 200) {
        message.success('补发成功');
        form.resetFields();
      }
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const payload = buildPendingCouponPayload(values);
      Modal.confirm({
        title: '确认补发优惠券？',
        width: 560,
        okText: '确认补发',
        cancelText: '取消',
        content: (
          <Descriptions
            size="small"
            bordered
            column={1}
            className={styles.confirmDescriptions}>
            <Descriptions.Item label="openId">{payload.openId}</Descriptions.Item>
            <Descriptions.Item label="userId">{payload.userId}</Descriptions.Item>
            <Descriptions.Item label="加密手机号">{payload.mobile}</Descriptions.Item>
          </Descriptions>
        ),
        onOk: () => doSubmit(payload),
      });
    } catch (error: any) {
      if (error?.errorFields) return;
      console.error(error);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.title}>补发优惠券</div>
        <Alert
          className={styles.notice}
          type="warning"
          showIcon
          message="提交后会调用待补发优惠券接口，userId 将使用 openId 的值。"
        />
        <Form
          form={form}
          layout="vertical">
          <Form.Item
            label="openId"
            name="openId"
            rules={[{ required: true, whitespace: true, message: 'openId不能为空' }]}>
            <Input
              allowClear
              placeholder="请输入微信openId"
              maxLength={120}
            />
          </Form.Item>
          <Form.Item
            label="加密手机号"
            name="mobile"
            rules={[{ required: true, whitespace: true, message: '加密手机号不能为空' }]}>
            <Input
              allowClear
              placeholder="请输入CDP加密手机号"
              maxLength={120}
            />
          </Form.Item>
          <div className={styles.footerActions}>
            <Space>
              <Button onClick={() => form.resetFields()}>重置</Button>
              <Button
                type="primary"
                loading={submitLoading}
                onClick={handleSubmit}>
                提交补发
              </Button>
            </Space>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ReissueThirdCoupon;
